import { toast } from 'react-toastify';

export function displayMessage({ title, message, type = toast.success }) {
  if (title && message) {
    toast(
      <>
        <h3 className="toaster-title">{title}</h3>
        <p className="toaster-message">{message}</p>
      </>,
      { type }
    );
  } else {
    // provide at least a message or a title
    toast(message || title, { type });
  }
}

export function errorMessage({ title, message, error }) {
  displayMessage({
    title,
    message: message ?? error?.response?.data ?? error.message,
    type: toast.TYPE.ERROR,
  });
}

export function successMessage({ title, message }) {
  displayMessage({ title, message, type: toast.TYPE.SUCCESS });
}

export function warningMessage({ title, message }) {
  displayMessage({ title, message, type: toast.TYPE.WARNING });
}
